module.exports = __webpack_public_path__ + "assets/StarVIcon.bb55a43473b661978e8f0baebd978980.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/StarVIcon.svg
// module id = 124
// module chunks = 0